module.exports = __webpack_public_path__ + "img/tractionaccount.701ce290.svg";